import { render, staticRenderFns } from "./Expressao.vue?vue&type=template&id=667f16d5&scoped=true&"
import script from "./Expressao.vue?vue&type=script&lang=js&"
export * from "./Expressao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "667f16d5",
  null
  
)

export default component.exports